
<!-- HEADER -->
<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
      <p class="bread-crumbs"><a [routerLink]="['/dash/reports']" *ngIf="userData.level <= 3">Reportes</a>
          <a [routerLink]="['/dash/dispersions/']" *ngIf="userData.level >= 4">Reportes</a> / Tarjetas</p>
      <h2 class="">Reportes Tarjetas</h2>
  </div>
</div>

<!-- CONTENT -->
<div class="content-block">
  <!-- TOP CONTAINER  -->
  <div class="dx-card responsive-paddings">
    <!-- FILTERS -->
    <dx-form [(formData)]="filters" [colCount]="4" labelLocation="left" class="py-2">

      <!-- companyId -->
      <ng-container *ngIf="userData.level < 4">
        <dxi-item dataField="companyId" editorType="dxSelectBox" [editorOptions]="{ displayExpr: 'companyName', valueExpr:'id', items: companies, searchEnabled: true, value: null }">
          <dxo-label text="Empresa"></dxo-label>
        </dxi-item>
      </ng-container>

      <!-- search button -->
      <dxi-item>
        <div class="flex justify-content-center">
          <dx-button text="Generar Reporte" type="default" (onClick)="getUsersCards()"></dx-button>
        </div>
      </dxi-item>
    
    </dx-form>
  </div>

  <!-- DATA CONTAINER -->
  <div class="mt-4">
    <div class="dx-card responsive-paddings pt-2">

      <!-- DATAGRID -->
      <dx-data-grid [dataSource]="users" keyExpr="id" [showBorders]="true" [columnAutoWidth]="true" (onRowPrepared)="onRowPrepared($event)">
        
        <!-- CONFIG -->
        <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="Reporte de Tarjetas"></dxo-export>
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true"></dxo-pager>

        <!-- COLUMNS -->
        <dxi-column dataField="id" caption="No." dataType="number" alignment="center"></dxi-column>
        <dxi-column dataField="name" caption="Nombre" alignment="left"></dxi-column>
        <dxi-column dataField="lastName" caption="ApellidoP" alignment="left"></dxi-column>
        <dxi-column dataField="secondLastName" caption="ApellidoM" alignment="center"></dxi-column>
        <dxi-column dataField="email" caption="Email" alignment="left"></dxi-column>
        <dxi-column dataField="card.Tarjeta" caption="Tarjeta" alignment="center" cellTemplate="TarjetaTemplate"></dxi-column>
        <dxi-column dataField="card.NIP" caption="NIP" alignment="center"></dxi-column>
        <dxi-column [allowFiltering]="false" [allowSorting]="false" cellTemplate="cellTemplate">
          <div *dxTemplate="let data of 'cellTemplate'">
            <!-- <a (click)="goTo(['dash','users','detail',data.data.uid])">Ver</a> -->
            <a routerLink="../../../dash/users/detail/{{data.data.uid}}"><i style="font-size: 20px;" class="far fa-id-card"></i></a>
          </div>
        </dxi-column>


        <!-- Tarjeta Template -->
        <div *dxTemplate="let data of 'TarjetaTemplate'">
          <i class="far fa-credit-card mr-2"></i>
          <span>{{data.value}}</span>
        </div>

        <!--
        <dxo-master-detail [enabled]="true" template="detail" ></dxo-master-detail>
        <div *dxTemplate="let data of 'detail'">
          <h5>Detalle</h5>
        </div>
        -->

      </dx-data-grid>


    </div>
  </div>

</div>